import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../Select/BaseSelectorReadonlyToInput";

class GroupSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: props.title || 'Grupo',
      label: 'friendlyName',
      url: 'alerts/v1/notifications-groups'
    };
  }

  componentWillMount() {
    this.props.defaultValueFunction && this.props.defaultValueFunction(this);
  }
}

GroupSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};
export default GroupSelector;


// WEBPACK FOOTER //
// ./src/component/BizGroup/GroupSelector.js